export enum CollaborationDataType {
  // avoiding 0 to prevent confusion with falsy values
  figJam = 1,
}
